import { callFetch } from './serviceHelpers';

export const getProductConfiguration = async productUrl => {
  const response = await callFetch(productUrl, 'GET');

  return response;
};
